<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{
              $t('luckyDrawReward.currentDisplayOrder')
            }}</label>
            <input
              type="number"
              readonly
              class="form-control"
              v-model.number="model.display_order"
            />
            <div class="validate ts-text-xs" v-if="errors.has('display_order')">
              {{ errors.first('display_order') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('luckyDrawReward.newDisplayOrder') }}
            </label>
            <input
              type="number"
              class="form-control"
              v-model.number="model.new_display_order"
            />
            <small>
              <i
                >Min: {{ model.min_order }} - Max: {{ model.max_order }} &
                Diffrent from:
                {{ model.display_order }}
              </i>
            </small>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('new_display_order')"
            >
              {{ errors.first('new_display_order') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              color="primary"
              @click.prevent="onChangeOrders"
              :waiting="waiting"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'luckyDrawReward',
  data () {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      model: {
        display_order: null,
        new_display_order: null,
        id: null,
        min_order: null,
        max_order: null
      }
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('luckyDraw/luckyDrawReward', ['edit_data']),
    isUpdate () {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    ...mapActions('luckyDraw/luckyDrawAvailableItem', ['getFormViewData']),
    async getAvailableOrder () {
      this.loading = true
      await this.getFormViewData({
        params: {
          fnName: 'availableOrder',
          id: this.model.id
        },
        index: 'availableOrder'
      })
        .then(response => {
          this.model.min_order = response.data.availableOrder.min_order
          this.model.max_order = response.data.availableOrder.max_order
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onChangeOrders () {
      this.waiting = true
      this.$store
        .dispatch('luckyDraw/luckyDrawReward/changeOrders', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.display_order = this.edit_data.display_order
        this.model.id = this.edit_data.id
      }
      this.getAvailableOrder()
    }
  }
}
</script>
